export const types = {
    SET_CEDIP_FETCHING: "cedip/SET_CEDIP_FETCHING",
    FILTER_CEDIP_LIST: "cedip/CEDIP_LIST_REQUEST",
    SET_CEDIP_FILTERS: "cedip/CHANGE_CEDIP_FILTERS",
    SET_CEDIP_LIST: "cedip/CEDIP_LIST_SUCCESS",
    SET_CEDIP_OPTION: "cedip/SET_CEDIP_OPTION",
    SET_CEDIP_ACTION: "cedip/SET_CEDIP_ACTION",
    CEDIP_READ: "cedip/CEDIP_READ",
    SET_TRANSMIT_CEDIP: "cedip/SET_TRANSMIT_CEDIP",
    CLEAN_CEDIP_ACTION: "cedip/CLEAN_CEDIP_ACTION",
    CEDIP_TICKET_SUCCESS: "cedip/CEDIP_TICKET_SUCCESS",
    CLEAN_CEDIP_TICKET: "cedip/CLEAN_CEDIP_TICKET",
    TRANSMIT_CEDIP_BENEFICIARY: "cedip/TRANSMIT_CEDIP_BENEFICIARY",

    DOWNLOAD_DETAIL_CEDIP_REQUEST: "cedip/DOWNLOAD_DETAIL_CEDIP_REQUEST",
    DOWNLOAD_DETAIL_CEDIP_FAILURE: "cedip/DOWNLOAD_DETAIL_CEDIP_FAILURE",
    DOWNLOAD_DETAIL_CEDIP_SUCCESS: "cedip/DOWNLOAD_DETAIL_CEDIP_SUCCESS",

    ACTION_CEDIP_ACCEPT_TERM: "cedip/ACTION_CEDIP_ACCEPT_TERM",
    ACTION_CEDIP_ACCEPT_TERM_SUCCESS: "cedip/ACTION_CEDIP_ACCEPT_TERM_SUCCESS",
    ACTION_CEDIP_ACCEPT_TERM_FAILURE: "cedip/ACTION_CEDIP_ACCEPT_TERM_FAILURE",
    TRANSMIT_CEDIP_PREVIEW: "cedip/TRANSMIT_CEDIP_PREVIEW",
    TRANSMIT_CEDIP_PREVIEW_SUCCESS: "cedip/TRANSMIT_CEDIP_PREVIEW_SUCCESS",
    TRANSMIT_CEDIP_PREVIEW_FAILURE: "cedip/TRANSMIT_CEDIP_PREVIEW_FAILURE",

    ACTION_CEDIP: "CEDIP/ACTION_CEDIP_REQUEST",
};

export const INITIAL_STATE = {
    fetching: false,
    fetchingDownload: false,
    generalConditionsShowTransmit: false,
    status: null,
    optionCedip: "",
    selectedActionCedip: "",
    cedipList: [],
    cedipFilters: {},
    cedipPagination: {},
    cedipTicket: { status: "", idTransaction: "" },
    idSelectedCedip: null,
    selectedCedip: {},
    transmitCedipData: {},
    hasMoreData: false,
};

export default (state = INITIAL_STATE, action = {}) => {
    const {
        optionCedip,
        cedipList,
        beneficiary,
        transmitCedipData,
        selectedActionCedip,
        generalConditionsShowTransmit,
        cedipFilters,
        cedipTicket,
        pageNumber,
        totalPages,
    } = action;

    switch (action.type) {
        case types.SET_CEDIP_FETCHING:
            return {
                ...state,
                fetching: false,
                fetchingDownload: false,
            };
        case types.FILTER_CEDIP_LIST:
            return {
                ...state,
                fetching: true,
                fetchingDownload: false,
            };
        case types.SET_CEDIP_FILTERS:
            return {
                ...state,
                cedipFilters,
                cedipList: [],
            };
        case types.SET_CEDIP_LIST:
            return {
                ...state,
                cedipList: [...state.cedipList, ...cedipList],
                hasMoreData: pageNumber < totalPages,
                cedipPagination: { totalPages, pageNumber },
            };
        case types.SET_CEDIP_OPTION:
            return {
                ...state,
                optionCedip,
                cedipList: [],
            };
        case types.SET_CEDIP_ACTION:
            return {
                ...state,
                selectedActionCedip,
            };
        case types.CEDIP_READ: {
            const selectedCedip = state.cedipList.find((item) => item.cedipId === action.cedipId);
            return {
                ...state,
                selectedCedip,
                idSelectedCedip: action.cedipId,
                fetching: false,
                fetchingDownload: false,
            };
        }
        case types.SET_TRANSMIT_CEDIP:
            return {
                ...state,
                transmitCedipData,
            };
        case types.DOWNLOAD_DETAIL_CEDIP_REQUEST:
            return {
                ...state,
                fetchingDownload: true,
            };
        case types.DOWNLOAD_DETAIL_CEDIP_FAILURE:
        case types.TRANSMIT_CEDIP_PREVIEW_FAILURE:
        case types.ACTION_CEDIP_ACCEPT_TERM_FAILURE:
        case types.DOWNLOAD_DETAIL_CEDIP_SUCCESS:
            return {
                ...state,
                fetchingDownload: false,
            };
        case types.CLEAN_CEDIP_ACTION:
            return {
                ...state,
                cedipList: [],
                transmitCedipData: {},
                selectedCedip: {},
            };
        case types.CEDIP_TICKET_SUCCESS:
            return {
                ...state,
                cedipTicket,
            };
        case types.CLEAN_CEDIP_TICKET:
            return {
                ...state,
                cedipTicket: { status: "", idTransaction: "" },
                fetching: false,
            };
        case types.TRANSMIT_CEDIP_PREVIEW_SUCCESS:
            return {
                ...state,
                generalConditionsShowTransmit,
                fetching: false,
            };
        case types.TRANSMIT_CEDIP_BENEFICIARY:
            return { ...state, transmitCedipData: { ...state.transmitCedipData, beneficiary } };
        default:
            return state;
    }
};

export const actions = {
    filterCedipList: (filters) => ({
        type: types.FILTER_CEDIP_LIST,
        filters,
    }),
    setCedipFilters: (cedipFilters) => ({
        type: types.SET_CEDIP_FILTERS,
        cedipFilters,
    }),
    setCedipOption: (optionCedip) => ({
        type: types.SET_CEDIP_OPTION,
        optionCedip,
    }),
    setCedipAction: (selectedActionCedip) => ({
        type: types.SET_CEDIP_ACTION,
        selectedActionCedip,
    }),
    readCedip: (cedipId) => ({
        type: types.CEDIP_READ,
        cedipId,
    }),
    beneficiaryCedip: (beneficiary, stringType) => ({
        type: stringType,
        beneficiary,
    }),
    setTransmitCedip: (transmitCedipData) => ({
        type: types.SET_TRANSMIT_CEDIP,
        transmitCedipData,
    }),
    downloadDetailCedip: (cedip, format) => ({
        type: types.DOWNLOAD_DETAIL_CEDIP_REQUEST,
        cedip,
        format,
    }),
    actionCedip: (transmitCedipDataTemp, formikBag, credentialType) => ({
        type: types.ACTION_CEDIP,
        transmitCedipDataTemp,
        formikBag,
        credentialType,
    }),
    getTermTransmit: () => ({
        type: types.TRANSMIT_CEDIP_PREVIEW,
    }),
    acceptTermTransmit: () => ({
        type: types.ACTION_CEDIP_ACCEPT_TERM,
    }),
    cleanCedipTicket: () => ({
        type: types.CLEAN_CEDIP_TICKET,
    }),
};

export const selectors = {
    getFetching: ({ cedip }) => cedip.fetching,
    getCedipList: ({ cedip }) => cedip.cedipList,
    getCedipFilters: ({ cedip }) => cedip.cedipFilters,
    getCedipOption: ({ cedip }) => cedip.optionCedip,
    getSelectedCedip: ({ cedip }) => cedip.selectedCedip,
    getSelectedAction: ({ cedip }) => cedip.selectedActionCedip,
    getTransmitCedipData: ({ cedip }) => cedip.transmitCedipData,
};
